import React from "react";

const NonprofitSupportSection = () => (
  <section className="py-20 bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
    {/* Subtle keynote accent shapes */}
    <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-green-500/20 rounded-full filter blur-3xl -z-10" />
    <div className="absolute bottom-1/4 right-1/4 w-40 h-40 bg-blue-500/20 rounded-full filter blur-3xl -z-10" />
    {/* Subtle green accent shapes for keynote feel */}
    <div className="absolute inset-0 pointer-events-none z-0">
      <div className="absolute left-1/2 top-0 w-72 h-72 bg-gradient-to-tr from-green-500/10 via-green-700/10 to-transparent rounded-full blur-2xl opacity-40 -translate-x-1/2" />
      <div className="absolute right-10 bottom-0 w-44 h-44 bg-green-400/10 rounded-full blur-2xl opacity-20" />
    </div>
    <div className="absolute inset-0 pointer-events-none z-0">
      <div className="absolute left-1/2 top-0 w-80 h-80 bg-gradient-to-tr from-green-300/30 via-blue-400/20 to-purple-500/20 rounded-full blur-3xl opacity-60 animate-pulse-slow -translate-x-1/2" />
      <div className="absolute right-10 bottom-0 w-56 h-56 bg-gradient-to-br from-yellow-300/10 via-pink-400/20 to-green-400/10 rounded-full blur-2xl opacity-40 animate-pulse-slower" />
    </div>
    <div className="container mx-auto px-6">
      <div className="text-center mb-10">
        <h2 className="text-3xl md:text-5xl font-bold mb-6">
          <span className="text-green-400"> B.Y.O.N.</span>
        </h2>
        <p className="text-xl text-gray-400 max-w-3xl mx-auto mb-4">
          Bring your own NPO{" "}
          <span className="font-bold text-white">CORAA makes them faster.</span>
        </p>
        <p className="text-lg text-green-300 max-w-3xl mx-auto mb-6">
          Looking to discover new ones? We've got{" "}
          <span className="font-bold">verified partners.</span>
        </p>
        <a
          href="/nonprofit"
          className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-full font-medium hover:bg-green-700 transition-colors text-lg"
        >
          Are you a Nonprofit? Learn how CORAA saves you 100s of hours
        </a>
      </div>
    </div>
  </section>
);

export default NonprofitSupportSection;
